<v-dialog v-model="popupVisible" max-width="400" max-height="height">
    <v-card>
        <v-card-title class="text-h5">{{ title }}</v-card-title>
        <v-card-text>{{ message }}</v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="popupVisible = false">
                {{ button }}
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>